import { schoolReportsApi } from "./schoolReports";

export const assessmentTreatmentPlans = schoolReportsApi.injectEndpoints({
  endpoints: (builder) => ({
    createGoal: builder.mutation({
      query: ({ assessmentId, data, clientType = "school" }) => ({
        url: `/${clientType}/assesment-goals-strategy/create/${assessmentId}`,
        method: 'POST',
        data,
      })
    }),
    updateGoal: builder.mutation({
      query: ({ goalId, data, clientType = "school", method = "PATCH" }) => ({
        url: `/${clientType}/assesment-goals-strategy/update/${goalId}`,
        method,
        data,
      })
    }),
    deleteGoal: builder.mutation({
      query: ({ goalId, clientType = "school" }) => ({
        url: `/${clientType}/assesment-goals-strategy/remove/${goalId}`,
        method: 'DELETE',
      })
    }),
  }),
});

export const {
  useCreateGoalMutation,
  useUpdateGoalMutation,
  useDeleteGoalMutation,
} = assessmentTreatmentPlans;